import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from "@angular/core";

import { Subject } from "rxjs";

import { DisposeMixin, EmptyClassInstance } from "../shared-library/mixins/dispose.mixin";
import { ExternalConfigurationService } from "../shared-library/services/configuration/external-configuration.service";
import { BrowserWindowService } from "../shared-library/services/environment/browser-window.service";
import { QueryStringSerializationService } from "../shared-library/services/environment/query-string-serialization.service";

import { SearchTabAlias } from "./enums/search-tab-alias.enum";
import { BaseSearchParametersModel } from "./models/base-search-parameters.model";
import { BaseSearchTabConfigModel } from "./models/base-search-tab-config.model";
import { SearchPageConfigModel } from "./models/search-page-config.model";
import { CmsLinkModel } from "./models/cms-link.model";

@Component({
    selector: "pcg-ng-advanced-search",
    template: require('./advanced-search.component.html')
})
export class AdvancedSearchComponent extends DisposeMixin(EmptyClassInstance) implements OnInit, AfterViewInit, OnDestroy {
    public tabAlias = SearchTabAlias;

    public searchPageConfig: Array<BaseSearchTabConfigModel>;
    public breadcrumbs: Array<CmsLinkModel>;
    public pageTitle: string;
    public activeTabConfig: BaseSearchTabConfigModel = null;
    public activeTabChangedEvent: Subject<BaseSearchTabConfigModel> = new Subject<BaseSearchTabConfigModel>();

    public constructor(
        private _domElement: ElementRef,
        private _configurationService: ExternalConfigurationService<SearchPageConfigModel>,
        private _browserWindowService: BrowserWindowService,
        private _serializationService: QueryStringSerializationService,
    ) {
        super();
    }

    public ngOnInit(): void {
        this._configurationService.initialize(this._domElement);

        this.searchPageConfig = this._configurationService.config.searchPageConfig;
        this.breadcrumbs = this._configurationService.config.breadcrumbs;
        this.pageTitle = this._configurationService.config.pageTitle;

        this.setActiveTab();

        if(!this.youtubeApiLoaded()) {
            const tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            document.body.appendChild(tag);
        }
    }

    public ngAfterViewInit(): void {
        setTimeout(() => {
            const activeTab = this.searchPageConfig.find(searchTab => searchTab.isActive);
            this.activeTabChangedEvent.next(activeTab);
        });
    }

    public ngOnDestroy(): void {
        this.dispose();
    }

    public onActiveTabChanged(activeTab: BaseSearchTabConfigModel): void {
        this.searchPageConfig.forEach(searchTab => {
            if (searchTab.isActive) {
                searchTab.wasActive = true;
            }
            searchTab.isActive = false;
        });
        activeTab.isActive = true;
        this.activeTabConfig = activeTab;
        this.activeTabChangedEvent.next(activeTab);
    }

    private setActiveTab(): void {
        const searchString = this._browserWindowService.getQueryString();
        const searchParams = this._serializationService.deserialize<BaseSearchParametersModel>(searchString);
        const activeTabAlias = searchParams.searchTab;
        let activeTabConfig: BaseSearchTabConfigModel = null;

        if (activeTabAlias) {
            activeTabConfig = this.searchPageConfig.find(tabConfig => tabConfig.tabAlias === activeTabAlias);
        }

        if (!activeTabConfig) {
            activeTabConfig = this.searchPageConfig.find(tabConfig => tabConfig.isActive);
        }

        if (!activeTabConfig) {
            activeTabConfig = this.searchPageConfig[0];
        }

        this.searchPageConfig.forEach(tabConfig => tabConfig.isActive = false);

        activeTabConfig.isActive = true;
        this.activeTabConfig = activeTabConfig;
    }

    private youtubeApiLoaded(): boolean {
        return !!window.YT;
    }
}
